import { type SVGProps } from "react";

export interface HomePinIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const HomePinIcon = ({ className, ...props }: HomePinIconProps) => {
  const filterId = "home-pin-filter0";
  const maskId = "home-pin-mask0";

  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filterId})`}>
        <path
          d="M18.7193 21.624C18.7193 22.543 11.9993 23.8 11.9993 23.8C11.9993 23.8 5.27932 22.543 5.27932 21.624C5.27932 20.7049 8.28796 19.96 11.9993 19.96C15.7107 19.96 18.7193 20.7049 18.7193 21.624Z"
          fill="black"
          fillOpacity="0.15"
        />
      </g>
      <mask
        fill="black"
        height="24"
        id={maskId}
        maskUnits="userSpaceOnUse"
        width="21"
        x="1.91602"
        y="0.210938"
      >
        <rect
          fill="white"
          height="24"
          width="21"
          x="1.91602"
          y="0.210938"
        />
        <path d="M11.958 1.21094C16.9516 1.21113 21 5.25925 21 10.2529C21 15.022 13.4518 21.5414 12.5889 22.2705L11.958 22.8047L11.3301 22.2676C10.4653 21.5435 2.91603 15.0225 2.91602 10.2529C2.91602 5.25914 6.96421 1.21094 11.958 1.21094Z" />
      </mask>
      <path
        d="M11.958 1.21094C16.9516 1.21113 21 5.25925 21 10.2529C21 15.022 13.4518 21.5414 12.5889 22.2705L11.958 22.8047L11.3301 22.2676C10.4653 21.5435 2.91603 15.0225 2.91602 10.2529C2.91602 5.25914 6.96421 1.21094 11.958 1.21094Z"
        fill="#A11733"
      />
      <path
        d="M11.958 1.21094L11.958 0.210938H11.958V1.21094ZM21 10.2529L22 10.2529V10.2529H21ZM12.5889 22.2705L11.9435 21.5067L11.9427 21.5073L12.5889 22.2705ZM11.958 22.8047L11.308 23.5646L11.9547 24.1178L12.6042 23.5679L11.958 22.8047ZM11.3301 22.2676L11.9801 21.5076L11.9721 21.5009L11.3301 22.2676ZM2.91602 10.2529H1.91602V10.2529L2.91602 10.2529ZM11.958 1.21094L11.958 2.21094C16.3994 2.2111 20 5.81157 20 10.2529H21H22C22 4.70693 17.5039 0.211146 11.958 0.210938L11.958 1.21094ZM21 10.2529L20 10.2529C20 11.1997 19.6182 12.3255 18.9337 13.5531C18.2572 14.7662 17.3329 15.9944 16.3602 17.1242C14.4154 19.3832 12.3583 21.1562 11.9435 21.5067L12.5889 22.2705L13.2343 23.0343C13.6823 22.6557 15.8308 20.8044 17.8758 18.4291C18.898 17.2418 19.9147 15.9004 20.6805 14.5271C21.4383 13.1681 22 11.6906 22 10.2529L21 10.2529ZM12.5889 22.2705L11.9427 21.5073L11.3118 22.0415L11.958 22.8047L12.6042 23.5679L13.2351 23.0337L12.5889 22.2705ZM11.958 22.8047L12.608 22.0448L11.9801 21.5077L11.3301 22.2676L10.6801 23.0275L11.308 23.5646L11.958 22.8047ZM11.3301 22.2676L11.9721 21.5009C11.5598 21.1556 9.50194 19.3837 7.55648 17.1247C6.58356 15.9951 5.65909 14.7668 4.98248 13.5535C4.29789 12.3259 3.91602 11.1999 3.91602 10.2529L2.91602 10.2529L1.91602 10.2529C1.91602 11.6908 2.47781 13.1685 3.23573 14.5276C4.00163 15.9011 5.01853 17.2426 6.04103 18.4299C8.08639 20.8048 10.2356 22.6554 10.6881 23.0343L11.3301 22.2676ZM2.91602 10.2529H3.91602C3.91602 5.81142 7.5165 2.21094 11.958 2.21094V1.21094V0.210938C6.41193 0.210938 1.91602 4.70685 1.91602 10.2529H2.91602Z"
        fill="white"
        mask={`url(#${maskId})`}
      />
      <path
        d="M16.375 12.1244H15.75V8.51112C15.7502 8.42399 15.7319 8.33782 15.6962 8.25834C15.6605 8.17886 15.6082 8.1079 15.543 8.05018L12.418 5.21034C12.3034 5.10521 12.1535 5.04688 11.998 5.04688C11.8425 5.04688 11.6927 5.10521 11.5781 5.21034L8.45312 8.05018C8.38914 8.10872 8.33804 8.17993 8.30307 8.25928C8.2681 8.33864 8.25003 8.4244 8.25 8.51112V12.1244H7.625C7.54212 12.1244 7.46263 12.1573 7.40403 12.2159C7.34542 12.2745 7.3125 12.354 7.3125 12.4369C7.3125 12.5198 7.34542 12.5993 7.40403 12.6579C7.46263 12.7165 7.54212 12.7494 7.625 12.7494H16.375C16.4579 12.7494 16.5374 12.7165 16.596 12.6579C16.6546 12.5993 16.6875 12.5198 16.6875 12.4369C16.6875 12.354 16.6546 12.2745 16.596 12.2159C16.5374 12.1573 16.4579 12.1244 16.375 12.1244ZM12.9375 12.1244H11.0625V10.2494C11.0625 10.1665 11.0954 10.087 11.154 10.0284C11.2126 9.96983 11.2921 9.9369 11.375 9.9369H12.625C12.7079 9.9369 12.7874 9.96983 12.846 10.0284C12.9046 10.087 12.9375 10.1665 12.9375 10.2494V12.1244Z"
        fill="white"
      />
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="7.0967"
          id={filterId}
          width="16.6963"
          x="3.65087"
          y="18.3315"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            mode="normal"
            result="shape"
          />
          <feGaussianBlur
            result="effect1_foregroundBlur_5049_71024"
            stdDeviation="0.814214"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default HomePinIcon;
